import { injectApp } from "../app";
import App from "./login.vue";
injectApp(App);
